var bag_checkmark = "https://shopfront-cdn.tekoapis.com/static/97ff32f4d297003f.svg";

export { bag_checkmark as default };
